import React from 'react';
import { FileText, Send, Upload, Home, Activity } from 'lucide-react';
import { dashboardData } from './data';
export function MetricsGrid() {
  const {
    teamPerformance
  } = dashboardData;
  const metrics = [{
    title: 'Credit Pulls',
    data: teamPerformance.creditPulls,
    icon: FileText,
    color: 'text-blue-600',
    bgColor: 'bg-blue-600',
    lightBg: 'bg-blue-50',
    borderColor: 'border-blue-200',
    unitLabel: 'PER PULL'
  }, {
    title: 'Doc Outs',
    data: teamPerformance.docOuts,
    icon: Send,
    color: 'text-green-600',
    bgColor: 'bg-green-600',
    lightBg: 'bg-green-50',
    borderColor: 'border-green-200',
    unitLabel: 'PER DOC OUT'
  }, {
    title: 'Submissions',
    data: teamPerformance.submissions,
    icon: Upload,
    color: 'text-purple-600',
    bgColor: 'bg-purple-600',
    lightBg: 'bg-purple-50',
    borderColor: 'border-purple-200',
    unitLabel: 'PER SUBMISSION'
  }, {
    title: 'Closings',
    data: teamPerformance.closings,
    icon: Home,
    color: 'text-orange-500',
    bgColor: 'bg-orange-500',
    lightBg: 'bg-orange-50',
    borderColor: 'border-orange-200',
    unitLabel: 'PER CLOSING'
  }];
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-266">
      <div className="px-6 py-5 border-b border-slate-200 flex items-center gap-3 bg-white" data-id="element-267">
        <div className="w-9 h-9 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shrink-0" data-id="element-268">
          <Activity size={20} data-id="element-269" />
        </div>
        <div data-id="element-270">
          <h2 className="text-base font-bold text-[#0a1e5e] uppercase tracking-wide" data-id="element-271">
            Team Performance
          </h2>
          <p className="text-xs text-slate-500 mt-0.5" data-id="element-272">(Month to Date)</p>
        </div>
      </div>

      <div className="p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-273">
        {metrics.map((metric, index) => <div key={index} className={`border ${metric.borderColor} rounded-xl p-5 flex flex-col items-center text-center relative overflow-hidden h-full`} data-id="element-274">
            <div className={`absolute top-0 left-0 w-full h-1 ${metric.bgColor}`} data-id="element-275"></div>

            <div className={`w-12 h-12 rounded-full ${metric.bgColor} text-white flex items-center justify-center mb-4 shadow-sm`} data-id="element-276">
              <metric.icon size={24} data-id="element-277" />
            </div>

            <h3 className="text-sm font-bold text-slate-700 uppercase tracking-wider mb-2" data-id="element-278">
              {metric.title}
            </h3>

            <div className="flex items-baseline gap-1 mb-1" data-id="element-279">
              <span className={`text-3xl font-black ${metric.color}`} data-id="element-280">
                {metric.data.points.toLocaleString()}
              </span>
              <span className="text-xs font-bold text-slate-400" data-id="element-281">PTS</span>
            </div>

            <p className="text-xs font-bold text-slate-500 mb-4" data-id="element-282">
              {metric.data.los} LOs
            </p>

            <div className={`w-full py-2 rounded-lg ${metric.lightBg} mt-auto`} data-id="element-283">
              <p className={`text-[10px] font-bold ${metric.color} uppercase`} data-id="element-284">
                {metric.data.perUnit} PTS {metric.unitLabel}
              </p>
            </div>
          </div>)}
      </div>
    </div>;
}